import {
  SurveyDetails,
  SurveyFormEditor,
} from '@/pages/ats-job-creation/tabs/interview-plan/stage/activity/activity-sections/survey/components';

export const getSurveyTabsConfig = (
  detailsRef: any,
  formEditorRef: any,
  activity: any,
  surveyType: string,
  onSurveyTypeChange: (type: string) => void,
  selectedTemplate: any,
  selectOnChange: (value: any) => void,
  isScheduled?: boolean,
  isInterviewPlan?: boolean
) => [
  {
    id: 'details',
    label: 'Details',
    component: SurveyDetails,
    props: {
      formRef: detailsRef,
      activity: activity,
      onSurveyTypeChange,
    },
  },
  {
    id: 'email',
    label: 'Email',
    component: SurveyFormEditor,
    props: {
      formRef: formEditorRef,
      selectedTemplate,
      selectOnChange,
      activity: activity,
      surveyType,
      isScheduled,
      isInterviewPlan,
    },
  },
];
